import { fork } from 'redux-saga/effects';
import {addSaga}  from './test';

export default function* appSaga() {
  yield fork(addSaga);
}